var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyRbIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.329,
    height: 22.221,
    viewBox: "0 0 24.329 22.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-icon-4",
    d: "M11.628,10.871a.722.722,0,0,0,1.077,0l4.6-4.956A3.666,3.666,0,0,0,17.068.759a3.15,3.15,0,0,0-4.431.334l-.473.508L11.7,1.1A3.146,3.146,0,0,0,7.265.759a3.67,3.67,0,0,0-.237,5.156Zm12.249,3.368a1.37,1.37,0,0,0-1.8,0l-3.9,3.207a2.644,2.644,0,0,1-1.689.608h-5a.695.695,0,0,1,0-1.389H14.8A1.415,1.415,0,0,0,16.2,15.51a1.379,1.379,0,0,0-1.335-1.623H8.109a4.889,4.889,0,0,0-3.13,1.141L3.016,16.664H.676A.687.687,0,0,0,0,17.359v3.657a1.083,1.083,0,0,0,1.173,1.2H15.746a2.661,2.661,0,0,0,1.689-.608l6.386-5.251A1.413,1.413,0,0,0,23.876,14.238Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyRbIcon4);
export default __webpack_public_path__ + "static/media/why-rb-icon-4.2c84dc9e51aad70f21554e775c8b1505.svg";
export { ForwardRef as ReactComponent };